import React from 'react';
import RegisterForm from '../../components/RegisterForm/RegisterForm.component';

export default function Register(){
    return(
        <RegisterForm/>
    )
}
